// INTERFACES
import { DataTableHeader } from 'vuetify/types'
interface formatter {
  digits?: number
  formatter?:
    | 'average'
    | 'boolean'
    | 'currency'
    | 'date'
    | 'dateTime'
    | 'fileSize'
    | 'number'
    | 'percent'
    | 'phone'
    | 'time'
    | 'zip'
}
interface spans {
  rowspan?: number
  colspan?: number
}
interface append {
  text: string | number | null
  value: string
  align?: 'start' | 'center' | 'end'
  map?: 'yellowGradient' | 'blueGradient' | 'divergingGradient'
}

export interface JcdcTableHeader extends DataTableHeader, formatter {}
export interface PrependItem extends spans {
  title: string
}
export interface AppendItem extends PrependItem, formatter, append {}
export interface ExcelAppendItem extends spans, formatter, append {
  title?: string // Used in DataTable only
}
export interface items {
  [key: string]: string | number | boolean | null
}

// FUNCTIONS
export function condenseHeaders(
  headers: JcdcTableHeader[],
  prependHeader: PrependItem[][]
): JcdcTableHeader[] {
  const condenseHeaders = headers.map((item) => {
      return {
        ...item,
        text: 'NONE',
      }
    }),
    // Track rowspan cells
    rowSpanIndex: Array<string> = []

  prependHeader.forEach((row, index) => {
    let cellIndex = 0
    // ROW
    row.forEach((cell) => {
      // Skip row spanned cells
      if (rowSpanIndex.length > 0) {
        rowSpanIndex.forEach((spannedCell) => {
          if (spannedCell === `${index}:${cellIndex}`) {
            cellIndex++
          }
        })
      }
      // Colspan
      const colSpan = cell.colspan ? cell.colspan : 1
      for (let i = 0; i < colSpan; i++) {
        if (cell.title != '') {
          const text =
            condenseHeaders[cellIndex].text == 'NONE'
              ? cell.title
              : `${condenseHeaders[cellIndex].text} - ${cell.title}`
          Object.assign(condenseHeaders[cellIndex], { text })
        }
        if (cell.rowspan) {
          for (let i = 1; i < cell.rowspan; i++) {
            rowSpanIndex.push(`${i}:${cellIndex}`)
          }
        }
        cellIndex++
      }
    })
  })
  return headers.map((item, index) => {
    return {
      ...item,
      text:
        condenseHeaders[index].text == 'NONE'
          ? item.text
          : item.text == ''
          ? condenseHeaders[index].text
          : `${condenseHeaders[index].text} - ${item.text}`,
    }
  })
}

export function trimArray(array: string[]): string[] {
  return array.map((string) => string.trim())
}

export function noDataText(): string {
  return 'No data available for search criteria.'
}
